// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"3e997cd6","181":"b08956c6","224":"0f5c22f0","226":"68696e2a","353":"3814bafc","417":"591af9d9","453":"d5d2b939","481":"4c903cfb","589":"779143ba","611":"18210127","699":"56be7846","837":"d35a4331"}[chunkId] + ".chunk.js";
};